import styles from "./subtasks-tab.module.css";

import { useState, useEffect } from "react";

import { Flex, Empty, Spin, Button, Row, Col, Segmented } from "antd";

import PlusIcon from "@/icons/PlusIcon";
import ViewGridIcon from "@/icons/ViewGridIcon";
import TableIcon from "@/icons/TableIcon";
import Selector2Icon from "@/icons/Selector2Icon";
import SelectorIcon from "@/icons/SelectorIcon";

import TasksTable from "@/components/tables/TasksTable";
import TaskCard from "@/components/cards/TaskCard";
import TaskExportActions from "@/components/ui/TaskExportActions";
import ShowDeletedTasksSwitch from "@/components/inputs/ShowDeletedTasksSwitch";
import { TASK_EXPORT_ENABLED } from "@/constants/tasks";

// import SearchFrom3 from "@/components/inputs/SearchFrom3";

const SubtasksTab = ({
  data,
  isAdmins,
  pending,
  statuses,
  priorities,
  taskTypes,
  handleCopySubtask,
  handleEditSubtask,
  handleDelete,
  handleAddNew,
  handlePublishSubtask,
  handleAddActualCosts,
  handleEditPlannedCosts,
  unit_uuid,
  readOnly,
  showDeletedTasks,
  onShowDeletedTasksChange,
}) => {
  const [selectView, setSelectView] = useState("list");
  const [selectedTaskUuids, setSelectedTaskUuids] = useState([]);
  const [isExpandCards, setIsExpandCards] = useState(false);

  const handleTaskSelect = (uuid, checked) => {
    setSelectedTaskUuids((prev) =>
      checked ? Array.from(new Set([...prev, uuid])) : prev.filter((id) => id !== uuid),
    );
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        setSelectView("cards");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setSelectedTaskUuids((prev) =>
      prev.filter((uuid) => data.some((task) => task.uuid === uuid)),
    );
  }, [data]);

  return pending ? (
    <div className="spin" style={{ height: 100 }}>
      <Spin size="large" />
    </div>
  ) : !!data.length ? (
    <Flex vertical gap={15}>
      <Flex justify="space-between" gap={15} align="center">
        <ShowDeletedTasksSwitch
          checked={showDeletedTasks}
          onChange={onShowDeletedTasksChange}
          size="small"
        />

        <Flex justify="flex-end" gap={15} align="center">
          <TaskExportActions
            selectedTasks={selectedTaskUuids}
            onClear={() => setSelectedTaskUuids([])}
            isAdmins={isAdmins}
          />

          <Segmented
            value={selectView}
            options={[
              { value: "list", icon: <TableIcon /> },
              { value: "cards", icon: <ViewGridIcon /> },
            ]}
            onChange={(val) => {
              setSelectView(val);
            }}
            className={styles.segmented}
          />

          <Button
            icon={
              isExpandCards ? (
                <Selector2Icon style={{ fontSize: 16 }} />
              ) : (
                <SelectorIcon style={{ fontSize: 16 }} />
              )
            }
            onClick={() => setIsExpandCards(!isExpandCards)}
            className={styles.expandCards}
          />

          {!readOnly && (
            <Button
              type="primary"
              icon={<PlusIcon />}
              onClick={handleAddNew}
            ></Button>
          )}
        </Flex>
      </Flex>

      {selectView === "cards" ? (
        <Row gutter={[16, 16]}>
          {data.map((task) => (
            <Col xs={24} key={task.uuid}>
              <TaskCard
                task={task}
                statuses={statuses}
                priorities={priorities}
                taskTypes={taskTypes}
                onEdit={handleEditSubtask}
                onDelete={handleDelete}
                onCopyItem={handleCopySubtask}
                onPublishItem={handlePublishSubtask}
                isAdmins={isAdmins}
                unit={unit_uuid}
                isExpandCards={isExpandCards}
                selectable={TASK_EXPORT_ENABLED}
                selected={selectedTaskUuids.includes(task.uuid)}
                onSelect={TASK_EXPORT_ENABLED ? handleTaskSelect : undefined}
              />
            </Col>
          ))}
        </Row>
      ) : (
        <TasksTable
          data={data}
          loading={pending}
          statuses={statuses}
          priorities={priorities}
          taskTypes={taskTypes}
          pagination={false}
          onCopyItem={handleCopySubtask}
          onEditItem={handleEditSubtask}
          onDeleteItem={handleDelete}
          onPublishItem={handlePublishSubtask}
          onAddActualCosts={handleAddActualCosts}
          onEditPlannedCosts={handleEditPlannedCosts}
          unit={unit_uuid}
          isAdmins={isAdmins}
          scroll={{
            x: "100%",
            y: 5 * 51,
          }}
          resize
          selectedRowKeys={TASK_EXPORT_ENABLED ? selectedTaskUuids : undefined}
          onRowsSelect={TASK_EXPORT_ENABLED ? setSelectedTaskUuids : undefined}
        />
      )}
    </Flex>
  ) : (
    <>
      <Flex justify="space-between" gap={15} align="center">
        <ShowDeletedTasksSwitch
          checked={showDeletedTasks}
          onChange={onShowDeletedTasksChange}
          size="small"
        />

        <Flex justify="flex-end" gap={15} align="center">
          <TaskExportActions
            selectedTasks={selectedTaskUuids}
            onClear={() => setSelectedTaskUuids([])}
            isAdmins={isAdmins}
          />

          {!readOnly && (
            <Button
              type="primary"
              icon={<PlusIcon />}
              onClick={handleAddNew}
            ></Button>
          )}
        </Flex>
      </Flex>
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
    </>
  );
};

export default SubtasksTab;
